var demoPlayerController;

angular.module('procommTalentSearch').controller('DemoPlayerController', function($scope, procommService, procommFavoriteService, procommPlaylistService,pcShareService) {
    demoPlayer = this;
    testscope2 = this;
    demoPlayerController = this;
    demoPlayerController.scope = $scope;

    demoPlayer.procommService = procommService;

    $scope.procommService = procommService;
    $scope.procommFavoriteService = procommFavoriteService;
    $scope.procommPlaylistService = procommPlaylistService;
    $scope.pcShareService = pcShareService;
    $scope.volume_can_adjust = true;

    demoPlayer.wavesurfer = wavesurfer;

    demoPlayer.current_time = false;
    demoPlayer.duration = false;
    demoPlayer.current_track = false;

    $scope.searchState = procommService.searchState;

    $scope.talent = procommService.isPlayingState.talent;

    $scope.$watch('searchState.gender', function(newValue, oldValue) {
    }, true);

    $scope.isPlayingState = demoPlayer.procommService.isPlayingState;
    
    $scope.$watch('isPlayingState', function(newValue, oldValue) {
      if(newValue != oldValue ){
        demoPlayer.playPause();
      }
    }, true);

    $scope.$watch('isPlayingState.demo', function(newValue, oldValue) {

      // if(newValue != oldValue){
        demoPlayer.loadClip();
      // }

    });

    $scope.$watch('isPlayingState.talent', function(newValue, oldValue) {
    }, true);

  
    demoPlayer.loadClip = function(url){
      if(typeof demoPlayer.procommService.isPlayingState.demo.file === typeof undefined){
        console.log('no url');
        return;
      }
      // console.log(demoPlayer.procommService);
      $scope.duration_string = "X:XX";

      if(jQuery('.bar__range').data('ui-slider')){
        var current_volume = jQuery('.bar__range').slider( "option", "value" ) / 100;
      }
      else{
        var current_volume = 0.5;
      }
      // console.log('volume', wavesurfer.getVolume());
      wavesurfer.load(demoPlayer.procommService.isPlayingState.demo.file.url);
      wavesurfer.setVolume(current_volume);
      // demoPlayer.duration = wavesurfer.getDuration();
    }

    demoPlayer.playButton = function(){
      if(demoPlayer.procommService.isPlayingState.status ){
        demoPlayer.procommService.isPlayingState.status = false;
      }
      else{
        demoPlayer.procommService.isPlayingState.status = true;
      }
    }

    demoPlayer.playPause = function(){
      if(wavesurfer.isPlaying() != demoPlayer.procommService.isPlayingState.status){
        wavesurfer.playPause();
      }
    };

    demoPlayer.getCurrentTrackIndex = function(){
      for(index in demoPlayer.procommService.search_results){
        item = demoPlayer.procommService.search_results[index];

        if($scope.isPlayingState.talent == item){
          return parseInt(index);
        }
      }
      return -1;
    }

    demoPlayer.nextTrack = function(){
      var current_index = demoPlayer.getCurrentTrackIndex();
      var isPlayingState = $scope.isPlayingState;

      var target_style = demoPlayer.procommService.searchState.style;
      if(target_style == ""){
        target_style = "Commercial";
      }

      var target_index = current_index + 1;
      var demo_index = target_style;


      if(jQuery('body').hasClass('single-talent')){
        // target_index = current_index;

        // console.log('tes123', demoPlayer.procommService.search_results[target_index].demos, demoPlayer.procommService.search_results[target_index].primary_demo);

        // if(demo_index == "Commercial" && demoPlayer.procommService.search_results[target_index].primary_demo.demo_type.name == "Commercial"){
        //   console.log('hi');
        //   demo_index = demoPlayer.procommService.search_results[target_index].demos[0].demo_type.name;

        // }
        // else{
        //     var next = false;
        //     for(index in demoPlayer.procommService.search_results[target_index].demos){
        //       var a_demo = demoPlayer.procommService.search_results[target_index].demos[index];

        //       console.log('testing',demo_index, a_demo.demo_type.name);
        //       if(demo_index == a_demo.demo_type.name){
        //         next = true;
        //       }
        //       if(next){
        //         console.log(next);
        //         demo_index = a_demo.demo_type.name;
        //         break;
        //       }
        //     }
        // }

        
      }
      else{
        
      }

      isPlayingState.demo = demoPlayer.procommService.search_results[target_index].demos_by_style[demo_index][0];
      isPlayingState.talent = demoPlayer.procommService.search_results[target_index];
    };

    demoPlayer.previousTrack = function(){
      var current_index = demoPlayer.getCurrentTrackIndex();
      var isPlayingState = $scope.isPlayingState;

      var target_style = demoPlayer.procommService.searchState.style;
      if(target_style == ""){
        target_style = "Commercial";
      }

      var target_index = current_index - 1;
      isPlayingState.demo = demoPlayer.procommService.search_results[target_index].demos_by_style[target_style][0];
      isPlayingState.talent = demoPlayer.procommService.search_results[target_index];

      // $scope.$apply();
    };

      demoPlayer.getTimeString = function(seconds){
        var minutes = Math.floor(seconds / 60);
        var seconds = Math.floor(seconds) % 60;

        if(seconds < 10){
          seconds = "0" + seconds;
        }

        return minutes + ":" + seconds;

      };

      demoPlayer.wavesurfer.on('ready', function () {
          console.log('ready');
          demoPlayer.current_time = 0;
          $scope.current_time_string = "0:00";
          demoPlayer.duration = wavesurfer.getDuration();


          if(demoPlayer.procommService.isPlayingState.status){
            demoPlayer.playPause();
          }

          $scope.$apply();
      }); 

      demoPlayer.wavesurfer.on('audioprocess', function () {
          var new_time = Math.floor(wavesurfer.getCurrentTime() );

          if( (! $scope.duration_string || $scope.duration_string == "X:XX") && wavesurfer.getDuration()){
                    console.log('checking duration', wavesurfer.getDuration() );
            $scope.duration_string = demoPlayer.getTimeString(wavesurfer.getDuration());
          }


          if(new_time != demoPlayer.current_time){
            demoPlayer.current_time = new_time;
            $scope.current_time_string = demoPlayer.getTimeString(new_time);
            $scope.$apply();

          }

          // PRC 05.2020
          var current_volume_can_adjust = $scope.volume_can_adjust;
          var current_volume = jQuery('.bar__range').slider( "option", "value" ) / 100;

          if(wavesurfer.getVolume() != current_volume && wavesurfer.getVolume() == 1){
              // iPad
              $scope.volume_can_adjust = false;
          }
          else{
              $scope.volume_can_adjust = true;
          }
          if(current_volume_can_adjust != $scope.volume_can_adjust){
              $scope.$apply();
          }
      });

      demoPlayer.wavesurfer.on('finish', function () {
          demoPlayer.procommService.isPlayingState.status = false;
          $scope.$apply();
      });

      // $scope.isPlayingState.demo = procommService.search_results[0].primary_demo;

})
;